var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28033 0.21967L8.9985 7.93725L16.7168 0.21967C17.0097 -0.0732233 17.4846 -0.0732233 17.7775 0.21967C18.0704 0.512563 18.0704 0.987437 17.7775 1.28033L10.059 8.9985L17.7775 16.7168C18.0704 17.0097 18.0704 17.4846 17.7775 17.7775C17.4846 18.0704 17.0097 18.0704 16.7168 17.7775L8.9985 10.059L1.28033 17.7775C0.987437 18.0704 0.512563 18.0704 0.21967 17.7775C-0.0732233 17.4846 -0.0732233 17.0097 0.21967 16.7168L7.93725 8.9985L0.21967 1.28033C-0.0732233 0.987437 -0.0732233 0.512563 0.21967 0.21967C0.512563 -0.0732233 0.987437 -0.0732233 1.28033 0.21967Z",
    fill: "#516A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.58bbc8d1f5f09a2497a6ed845a23a9d8.svg";
export { ForwardRef as ReactComponent };